module.exports = __webpack_public_path__ + "static/media/styledcomponents.3745d5de.png";